import { PlanType } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import * as React from 'react';

interface EnterpriseRefContextActions {
  scrollToRef(): void;
  setRef(ref: React.RefObject<HTMLElement>): void;
  shouldShowSuccsessMessage: boolean;
  showSuccsessMessage: React.Dispatch<React.SetStateAction<boolean>>;
}
export const EnterpriseRefContext = React.createContext<EnterpriseRefContextActions>(
  {} as any,
);

export const useEnterpriseRefContext = () =>
  React.useContext(EnterpriseRefContext);

interface EnterpriseTabContextProviderCompProps {
  rootStore: RootStore;
}
const EnterpriseTabContextProviderComp: React.FC<EnterpriseTabContextProviderCompProps> = ({
  children,
  rootStore,
}) => {
  const [ref, setRef] = React.useState<React.RefObject<HTMLElement>>(
    null as any,
  );
  const [shouldShowSuccsessMessage, showSuccsessMessage] = React.useState(
    false,
  );
  const scrollToRef = () => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' });
    showSuccsessMessage(false);
    const {
      appContext: { biLogger },
    } = rootStore!.appStore;
    biLogger.logRequestCallPopupLoad({ ppType: PlanType.Enterprise });
  };

  return (
    <EnterpriseRefContext.Provider
      value={{
        scrollToRef,
        setRef,
        shouldShowSuccsessMessage,
        showSuccsessMessage,
      }}
    >
      {children}
    </EnterpriseRefContext.Provider>
  );
};

export const EnterpriseTabContextProvider = withInjectedRootStore(
  EnterpriseTabContextProviderComp,
);
